import { render, staticRenderFns } from "./DiscountOverview.vue?vue&type=template&id=064a3805&scoped=true"
import script from "./DiscountOverview.vue?vue&type=script&lang=js"
export * from "./DiscountOverview.vue?vue&type=script&lang=js"
import style0 from "./DiscountOverview.vue?vue&type=style&index=0&id=064a3805&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "064a3805",
  null
  
)

export default component.exports